import React from "react";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";

function Footer(props) {
	const { sideLength } = props;
	return (
		<footer className="footer" id="footer">
			<div className="footer_info">
			<span className="highlight_text">Liệu CHƠI: </span>
Sử dụng các phím mũi tên <span className="highlight_text"> của bạn</span> để di chuyển
gạch. Gạch có cùng số
<span className="highlight_text"> hợp nhất thành một </span> khi chúng
chạm. Thêm chúng lên để tiếp cận
				<span className="highlight_text">
					{" "}
					{sideLength === 4 ? 2048 : 4096}!
				</span>
			</div>
			<a href="#header">
				<div className="game_rules highlight_text">
				Bắt đầu chơi <HiOutlineArrowNarrowRight />
				</div>
			</a>
		</footer>
	);
}

export default Footer;
